/* eslint-disable camelcase */
import { Comment } from "../../components/Comment/Comment";

export interface INote {
    note: string;
    fileUrl?: string;
    fileName?: string;
    user: {
        userId: string;
        username: string;
    };
    coach: {
        userId: string;
        username: string;
        avatar_url?: string;
    };
    createdAt: number;
}

type NotesProps = {
    notes: INote[];
};

export const Notes = (props: NotesProps) => (
    <div className="notes-cont">
        <h1 className="notes-title">Anmerkungen der Coaches</h1>
        {props.notes.map((note, index) => (
            <Comment
                key={index}
                avatar_url={note.coach.avatar_url}
                text={note.note}
                username={note.coach.username}
                file={note.fileUrl}
                filename={note.fileName}
            />
        ))}
    </div>
);
